export interface ApplicationSettings {
    dataCode: string;
    dataValue: string;
    description: string;
    effectiveFrom: string;
    effectiveTill: string;
}

export enum DisplayModes {
  CAROUSEL = 'carousel',
  SEQUENTIAL = 'sequential'
}
